import provinces from "./provinces";
import { Select } from "../../../../../utils/form";

const Province = ({ form: { control }, ...props }) =>
  <Select {...props} control={control} name="province" label="Provincia" list={provinces} variant="outlined" required style={{ width: "100%" }} />

export default Province;